<div class="m-4 flex text-sm">
  <div
    class="mr-8"
    data-qa-tag="fromDate"
  >
    <label
      class="mr-4"
      for="fromDate"
      >From Date</label
    >
    <p-datepicker
      inputId="fromDate"
      [(ngModel)]="filterData().fromDate"
      [showTime]="true"
      hourFormat="24"
      dateFormat="dd/mm/yy"
      [hideOnDateTimeSelect]="false"
    />
  </div>

  <div
    class="mr-8"
    data-qa-tag="toDate"
  >
    <label
      class="mr-4"
      for="toDate"
      >To Date:</label
    >
    <p-datepicker
      inputId="toDate"
      [(ngModel)]="filterData().toDate"
      [showTime]="true"
      hourFormat="24"
      dateFormat="dd/mm/yy"
      [hideOnDateTimeSelect]="false"
    />
  </div>

  <div
    class="mr-8"
    data-qa-tag="beaufort"
  >
    <label
      class="mr-4"
      for="beaufort"
      >Beaufort:</label
    >
    <p-multiselect
      #multiselect
      inputId="beaufort"
      [filter]="false"
      [options]="beaufortOptions"
      (onChange)="updateBeaufortSelection($event)"
      [(ngModel)]="filterData().beaufortSelected"
      optionLabel="name"
      placeholder=""
      [maxSelectedLabels]="3"
      [showToggleAll]="true"
      class="w-48"
      [selectedItemsLabel]="label()"
    >
      <ng-template pTemplate="header">
        <div class="absolute top-[9px] left-[45px]">All</div>
      </ng-template>
    </p-multiselect>
  </div>

  <div
    class="mr-8"
    data-qa-tag="draught"
  >
    <label
      class="mr-4"
      for="draught"
      >Draught:</label
    >
    <input
      pInputText
      type="number"
      [(ngModel)]="filterData().draught"
      class="w-28 pr-8"
    />
    <span class="-ml-6">m</span>
  </div>

  <div data-qa-tag="type">
    <label
      class="mr-4"
      for="type"
      >Type:</label
    >
    <p-select
      [options]="typeOptions"
      [(ngModel)]="filterData().typeSelected"
      optionLabel="name"
      class="w-48"
    />
  </div>
  <p-button
    class="button mb-5 ml-5"
    label="Reset Filters"
    data-qa-tag="reset-filters-btn"
    (onClick)="resetFilters()"
  ></p-button>
</div>
